import React from "react";
import { motion } from "framer-motion";

const FROM = { up: { y: 36 }, left: { x: -50 }, right: { x: 50 }, zoom: { scale: 0.92, y: 30 } };

export default function Reveal({ as = "div", dir = "up", delay = 0, className, children, ...rest }) {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, ...FROM[dir] }}
      whileInView={{ opacity: 1, x: 0, y: 0, scale: 1 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.8, delay, ease: [0.2, 0.7, 0.2, 1] }}
      {...rest}
    >
      {children}
    </M>
  );
}
